import React from "react";
import { Navigate } from "react-router-dom";

const PublicRoute = ({ component: Component, ...rest }) => {
  // Add your authentication logic here
  const user = JSON.parse(localStorage.getItem("user"));
  return !user ? <Component {...rest} /> : <Navigate to="/dashboard" replace />;
};
export default PublicRoute;
